export class BuildDetails {
  buildNumber = '';
}

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BuildDetailsService {
  public buildDetails: BuildDetails;

  constructor() {
    this.buildDetails = new BuildDetails();
  }
}

import { HttpContext, HttpHeaders, HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { SKIP_ERROR_LOGGING } from '../interceptors/http-error.interceptor';

@Injectable({ providedIn: 'root' })
export class BuildDetailsHttpService {
  constructor(private http: HttpClient, private buildDetailsService: BuildDetailsService) {}

  async fetchBuildDetails(): Promise<void> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache',
      }),
      context: new HttpContext().set(SKIP_ERROR_LOGGING, true),
    };

    try {
      const response = await lastValueFrom(this.http.get<BuildDetails>('assets/build-details.json', httpOptions));
      this.buildDetailsService.buildDetails = response;
    } catch (error) {
      console.error('Error fetching build details:', error);
    }
  }
}
